var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(0 -2.842170943040401e-14) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 C 20.187 90 0 69.814 0 45 C 0 20.187 20.187 0 45 0 c 24.814 0 45 20.187 45 45 C 90 69.814 69.814 90 45 90 z M 45 5.625 C 23.289 5.625 5.625 23.289 5.625 45 c 0 21.712 17.664 39.375 39.375 39.375 c 21.712 0 39.375 -17.663 39.375 -39.375 C 84.375 23.289 66.712 5.625 45 5.625 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(46.17984832069338 46.17984832069335) scale(1.82 1.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.96,
    y: 1.71,
    rx: 0,
    ry: 0,
    width: 34.55,
    height: 32.36,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.403 0 H 48.256 c -0.882 0 -1.597 0.715 -1.597 1.597 v 34.327 c 0 0.882 0.715 1.597 1.597 1.597 h 12.549 l 6.292 10.898 c 0.548 0.949 1.918 0.949 2.466 0 l 6.292 -10.898 h 12.549 c 0.882 0 1.597 -0.715 1.597 -1.597 V 1.597 C 90 0.715 89.285 0 88.403 0 z M 56.33 23.174 c -2.428 0 -4.396 -1.968 -4.396 -4.396 s 1.968 -4.396 4.396 -4.396 s 4.396 1.968 4.396 4.396 S 58.758 23.174 56.33 23.174 z M 68.33 23.174 c -2.428 0 -4.396 -1.968 -4.396 -4.396 s 1.968 -4.396 4.396 -4.396 s 4.396 1.968 4.396 4.396 S 70.758 23.174 68.33 23.174 z M 80.33 23.174 c -2.428 0 -4.396 -1.968 -4.396 -4.396 s 1.968 -4.396 4.396 -4.396 s 4.396 1.968 4.396 4.396 S 82.758 23.174 80.33 23.174 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.665 62.087 c 0.974 0.974 2.471 1.194 3.684 0.543 l 6.198 -3.328 c 11.764 2.454 21.211 7.851 28.004 16.618 c 0.016 -0.038 0.032 -0.074 0.049 -0.112 c -1.393 3.212 -2.871 6.667 -3.621 8.581 c -0.247 0.631 -0.615 1.208 -1.127 1.652 c -12.674 10.986 -37.89 -2.4 -57.191 -21.701 C 6.358 45.039 -7.028 19.823 3.958 7.149 c 0.444 -0.512 1.022 -0.88 1.652 -1.127 c 1.914 -0.75 5.369 -2.228 8.581 -3.621 c -0.038 0.016 -0.074 0.032 -0.112 0.049 c 8.767 6.793 14.164 16.24 16.618 28.004 l -3.328 6.198 c -0.651 1.213 -0.431 2.71 0.543 3.684 l 10.876 10.876 L 49.665 62.087 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.547 59.302 l 6.835 -3.669 c 0.964 -0.518 2.129 -0.493 3.07 0.066 l 19.017 11.285 c 1.357 0.805 1.903 2.489 1.268 3.933 c -0.599 1.363 -1.38 3.146 -2.185 5.003 L 59.547 59.302 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.698 30.453 l 3.669 -6.835 c 0.518 -0.964 0.493 -2.129 -0.066 -3.07 L 23.017 1.531 c -0.805 -1.357 -2.489 -1.903 -3.933 -1.268 c -1.363 0.599 -3.146 1.38 -5.003 2.185 L 30.698 30.453 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(190,190,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8fa82eb78fbb44ab00552111ea0559e5.svg";
export { ForwardRef as ReactComponent };